import { createRef } from 'react';
import { describe, expect, it } from 'vitest';

import { render } from '@dynatrace/strato-components-testing/vitest';

import { Content } from './Content.js';

describe('NotifyButton.Content', () => {
  it('forwards the ref', () => {
    const ref = createRef<HTMLDivElement>();
    const { container } = render(<Content ref={ref} />);

    expect(container.firstChild).toBe(ref.current);
  });

  it('forwards DOMProps', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} id="testid" />);

    expect(ref.current).toHaveAttribute('id', 'testid');
  });

  it('forwards AriaLabelingProps aria-label', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} aria-label="test-aria-label" />);
    expect(ref.current).toHaveAttribute('aria-label', 'test-aria-label');
  });

  it('forwards AriaLabelingProps aria-labelledby', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} aria-labelledby="test-aria-labelledby" />);
    expect(ref.current).toHaveAttribute(
      'aria-labelledby',
      'test-aria-labelledby',
    );
  });

  it('forwards AriaLabelingProps aria-describedby', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} aria-describedby="test-aria-describedby" />);
    expect(ref.current).toHaveAttribute(
      'aria-describedby',
      'test-aria-describedby',
    );
  });

  it('forwards AriaLabelingProps aria-details', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} aria-details="test-aria-details" />);
    expect(ref.current).toHaveAttribute('aria-details', 'test-aria-details');
  });

  it('forwards StylingProps className', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} className="test-classname" />);
    expect(ref.current).toHaveClass('test-classname');
  });

  it('forwards StylingProps style', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} style={{ background: 'red' }} />);
    expect(ref.current).toHaveStyle('background: red');
  });

  it('forwards MaskingProps data-dtrum-mask', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} data-dtrum-mask />);
    expect(ref.current).toHaveAttribute('data-dtrum-mask');
  });

  it('forwards MaskingProps data-dtrum-allow', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} data-dtrum-allow />);
    expect(ref.current).toHaveAttribute('data-dtrum-allow');
  });

  it('forwards DataTestId', () => {
    const ref = createRef<HTMLDivElement>();
    render(<Content ref={ref} data-testid="test-id" />);
    expect(ref.current).toHaveAttribute('data-testid', 'test-id');
  });

  describe('behavior tracking attributes', () => {
    it('should add data-dt-* attributes to NotifyButton.Content', () => {
      const ref = createRef<HTMLDivElement>();
      render(
        <Content
          ref={ref}
          data-dt-name="MyContent"
          data-dt-features="Feature1"
          data-dt-properties="key=value"
        />,
      );

      expect(ref.current).toHaveAttribute('data-dt-name', 'MyContent');
      expect(ref.current).toHaveAttribute('data-dt-features', 'Feature1');
      expect(ref.current).toHaveAttribute('data-dt-properties', 'key=value');
    });
  });
});
